export enum ReportsVisitsRoutes {
    avareagefieldvisitbyrep = "avareage-field-visits",
    // getfieldvisithistorybyrep = "field-visits-by-rep",
    getaccountfieldvisithistorybyrep = "account-field-visits-by-rep",
    getleadfieldvisithistorybyrep = "lead-field-visits-by-rep",
    // getterritorywisevisithistoryofrep = "visit-history",
    getterritorywiseaccountvisithistoryofrep = "account-visit-history-by-territory",
    getterritorywiseleadvisithistoryofrep = "lead-visit-history-by-territory",
    getterritorywiseaccountvisithistory = "account-visit-history",
    getterritorywiseleadvisithistory = "lead-visit-history"
}

export const ReportsVisitsNames = {
    avareagefieldvisitbyrep: "avareagefieldvisitbyrep",
    // getfieldvisithistorybyrep: "getfieldvisithistorybyrep",
    getaccountfieldvisithistorybyrep: "getaccountfieldvisithistorybyrep",
    getleadfieldvisithistorybyrep: "getleadfieldvisithistorybyrep",
    // getterritorywisevisithistoryofrep: "getterritorywisevisithistoryofrep",
    getterritorywiseaccountvisithistoryofrep: "getterritorywiseaccountvisithistoryofrep",
    getterritorywiseleadvisithistoryofrep: "getterritorywiseleadvisithistoryofrep",
    getterritorywiseaccountvisithistory: "getterritorywiseaccountvisithistory",
    getterritorywiseleadvisithistory: "getterritorywiseleadvisithistory",
    getaccountsurveyquestionresponses: "getaccountsurveyquestionresponses",
    getleadsurveyquestionresponses: "getleadsurveyquestionresponses"
} as const;


export const ReportsVisitsLabelName = {
    avareagefieldvisitbyrep: "Average Field Visits by Rep",
    getaccountfieldvisithistorybyrep: "Account Field Visits by Rep",
    getleadfieldvisithistorybyrep: "Lead Field Visits by Rep",
    getterritorywiseaccountvisithistoryofrep: "Account Field Visits by Territory",
    getterritorywiseleadvisithistoryofrep: "Lead Field Visits by Territory",
    getterritorywiseaccountvisithistory: "Account Visits Status",
    getterritorywiseleadvisithistory: "Lead Visits Status"
} as const;
